import axiosInstance from "./../helper/axiosIntanceApiZalo";
import axios from './../helper/axiosIntance';
import { normalizeStringInObject } from "../utils/normalize";

function getFormData(object) {
    const formData = new FormData();
    if (object) {
        Object.keys(object).forEach(key => formData.append(key, object[key]));
    }
    return formData;
}
const accept_connect = (params) => { 
    return axios.post('/widget/api/new_chat', normalizeStringInObject(params));
};
const send_message = (params)=>{
    return axios.post('/widget/api/sendMessageFromUser', normalizeStringInObject(params));
}
export default {
    accept_connect,
    send_message
}
